import keyboard from "@main/helpers/keyboard";

$(document).ready(function() {

    const $slider_sync1 = $(".js-slider-sync1");

    if($slider_sync1.length) {

        const $slider_sync2 = $slider_sync1.siblings(".js-slider-sync2");
        let carousel_length = 0;

        $slider_sync1.owlCarousel({
            items: 1,
            smartSpeed: 800,
            margin: 24,
            nav: false,
            autoplay: false,
            dots: false,
            loop: false,
            mouseDrag: false,
            touchDrag: false,
            onInitialized: function() {
                carousel_length = this.items().length;
            }
        });

        $slider_sync2.owlCarousel({
            dots: false,
            smartSpeed: 1000,
            margin: 24,
            navText: ["<svg><use href='#arrow-left'></use></svg>",
                "<svg><use href='#arrow-right'></use></svg>"],
            responsive: {
                0: {
                    items: 2,
                    nav: false,
                    stagePadding: 50,
                },
                768: {
                    items: 2,
                    nav: true,
                    stagePadding: 0,
                },
                990: {
                    items: 3,
                    nav: true,
                },
            },
        });

        $slider_sync2.find(".owl-item").on("click", function() {

            let index = parseInt($(this).find(".item").data("index"));

            $(this).parents(".js-slider-sync2").siblings(".js-slider-sync1").trigger("to.owl.carousel", [index - 1]);
            $(this).parents(".js-slider-sync2").find(".item").removeClass("active");
            $(this).find(".item[data-index="+ index +"]").addClass("active");

        }).filter(":first").click();

        //смена слайдера при открытии модального окна
        const  $btnOpen = $(".js-open-modal[data-modal=product]");

        let is_modal = false;

        $btnOpen.each(function() {

            $(this).on("click", () => {

                let index = $(this).data("index");
                is_modal = true;

                toOwlCarousel(index, $slider_sync1 , $slider_sync2);
            });
        });

        //смена слайдера при закрытии модального окна
        const  $btnClose = $slider_sync1.parents(".js-modal").find(".js-close-modal");

        $btnClose.each(function() {

            $(this).on("click", () => {

                let index = parseInt($(this).parents(".js-modal").find(".item.active").data("index"));
                is_modal = false;

                toOwlCarousel(index, $slider_sync1 , $slider_sync2);
            });
        });

        //перелючение модального слайдера на стрелки
        $(document).keyup(function(e) {

            let index = $(".js-modal .js-slider-sync1 .owl-item.active .item").data("index");

            if(is_modal) {

                if(e.keyCode == keyboard.ArrowRight) {

                    if(index < carousel_length) {
                        index++;
                    }
                }

                if(e.keyCode == keyboard.ArrowLeft) {

                    if(index > 1) {
                        index--;
                    }
                }

                toOwlCarouselModal(index);
            }

        });

        //переключение модального слайдера по клику на основную картинку

        $(".js-modal .js-slider-sync1 .owl-item").on("click", function() {

            let index =  parseInt($(this).find(".item").data("index"));

            if(index < carousel_length) {
                index++;
            }

            toOwlCarouselModal(index);
        });
    }

});

function toOwlCarousel(index, sync1, sync2) {

    sync1.trigger("to.owl.carousel", [index - 1]);
    sync2.trigger("to.owl.carousel", [index - 1]);

    sync2.find(".item").removeClass("active");
    sync2.find(".item[data-index="+ index +"]").addClass("active");
}

function toOwlCarouselModal(index) {

    $(".js-modal .js-slider-sync2 .owl-item").each(function() {

        if($(this).find(".item").data("index") == index) {

            $(this).trigger("click");
        }
    });

    $(".js-modal .js-slider-sync2").trigger("to.owl.carousel", [index - 1]);
}